module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.8.0-268.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.8.0.md
// module id = 711
// module chunks = 232